import type { MaybeRef } from 'vue';

export const volumeKeys = {
  all: ['volumes'] as const,
  volumes: (params?: MaybeRef<{ page: number; query?: string }>) =>
    [...volumeKeys.all, 'volumes', ...(params ? [params] : [])] as const,
  volume: (uuid: MaybeRef<string>) => [...volumeKeys.all, 'volume', uuid] as const,
};
